import { useEffect, useRef, useState } from 'react';
function useLocalStorageState(key, defaultValue = '', { serialize = JSON.stringify, deserialize = JSON.parse } = {}) {
    const [state, setState] = useState(() => {
        const valueInLocalStorage = window.localStorage.getItem(key);
        if (valueInLocalStorage) {
            try {
                return deserialize(valueInLocalStorage);
            }
            catch {
                window.localStorage.removeItem(key);
            }
        }
        return typeof defaultValue === 'function' ? defaultValue() : defaultValue;
    });
    const prevKeyRef = useRef(key);
    useEffect(() => {
        const prevKey = prevKeyRef.current;
        if (prevKey !== key) {
            window.localStorage.removeItem(prevKey);
        }
        prevKeyRef.current = key;
        try {
            window.localStorage.setItem(key, serialize(state));
        }
        catch {
            // does nothing
        }
    }, [key, state, serialize]);
    return [state, setState];
}
export default useLocalStorageState;
//# sourceMappingURL=useLocalStorageState.js.map